import React, { Component, Fragment } from 'react';
import { Flex, Image, Text } from 'rebass';
import styled from 'styled-components';
import { Route, Link, NavLink as RouterNavLink, Redirect, Switch } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import { LogoHeader } from '../components/Logo';
import Sidebar from '../components/SidebarV2';
import Menu from '../components/icons/Menu';
import HeaderAccount from '../components/HeaderAccount';
import Landing from './LandingV2';
import Account from './Account';
import MyAccount from './MyAccount';
import Consultations from './Consultations';
import Pharmacy from './Pharmacy';
import LabCenter from './LabCenter';
import Labs from './Labs';
import Practitioner from './Practitioner';
import Support from './Support';
import withSession from '../lib/withSession';
import withAnalytics from '../lib/withAnalytics';
import UploadLabResultsPage from './UploadLabResults';
import RegisterKit from './RegisterKit';
import RegisteredKit from './registerKit/registeredKit';
import LabScan from './LabScan';
import ViewRequisitionForm from './requisitionForms/viewRequisitionForm';
import ChangeEmail from './ChangeEmail';
import MapLocalAccountToAthenaId from './MapLocalAccountToAthenaId';
import ScheduleNutritionist from './ScheduleNutritionist';
import Schedule from './Schedule2';
import ScheduleBridge from './ScheduleBridge';
import UnregisterKitLocalDb from './UnregisterKitLocalDb';
import ImpersonatingChange from './ImpersonatingChange';
import LoadingScreen from '../components/LoadingScreen';
import { withApollo, Query } from 'react-apollo';
import { CURRENT_USER, ATHENA_CARD, APPOINTMENTS, LABS, GET_USER_PCP, GENERATE_CIRCLE_SO_CALLBACK, GET_LAB_ORDERS_LIST } from '../graphql';
import ScheduleNewPatientComplete from './ScheduleNewPatientComplete';
import MobileCommunicatorPage from './perpetualCommunicator/MobileCommunicatorPage';
import MobileCommunicatorGutResetPage from './giPerpetualCommunicator/MobileCommunicatorPage';
import MobileAsyncCommunicatorPage from './perpetualCommunicator/MobileCommunicatorPage';
// import MobileCommunicatorPage from './consultations/MobileCommunicatorPage';
import Div100vh from 'react-div-100vh';
import ResetPatientIntakeStatus from './ResetPatientIntakeStatus';
import registerKitPayment from './registerKit/registerKitPayment';
import ProfilePage from './Profile';
import FeatureTogglesManagement from './FeatureToggles';
import OneTimeCouponsManagement from './OneTimeCoupons';
import { isMobile, MobileOnlyView } from 'react-device-detect';
import AdminReports from './AdminReports';
import LabResultsTrendPage from './labs/labResultsTrendPage';
import Referral from './referral';
import AdminReferralList from './AdminReferralList';
import MobileCourseDesigner from './mobileCourseDesigner';
import MobileSymptomTrackers from './MobileSymptomTrackers';
import BatchBalanceAdjustment from './BatchBalanceAdjustment';
import BatchMapToNewProviderGroup from './batchMapToNewPatientId';
import PendingProfileCompletionUsers from './pendingProfileCompletionUsers';
import MobileCourses from './MobileCourses';
import MobileMotivationQuotes from './MobileMotivationQuotes';
import AdminSetMobileUserWeek from './AdminSetMobileUserWeek';
import MobileWebflowArticles from './MobileWebflowArticles';
import MobileRecipes from './MobileRecipes';
import { MySubscriptions } from './MySubscriptions';
import SubscribedBook from './subscribedLogin/SubscribedBook';
import { CancelMembership } from './mySubscriptions/cancellations/CancelMembership';
import SubscribedCall from './subscribedLogin/SubscribedCall';
import ScheduleCareManager from './scheduleCareManager/ScheduleCareManager';
import BecomeMember from './becomeMember/index';
import SubscriptionUpdated from './SubscriptionUpdated';
import SelectPlanPage from './selectPlanPage';
import { CancelSubscription } from './mySubscriptions/cancellations/CancelSubscription';
import PauseSubscription from './mySubscriptions/cancellations/PauseSubscription';
import MyCareTeam from './MyCareTeam';
import ChatCareTeam from './ChatCareTeam';
import SubscriptionChangesConfirm from './mySubscriptions/SubscriptionChangesConfirm';
import SubscribedPurchase from './subscribedLogin/SubscribedPurchase';
import MyPaymentMethods from './MyPaymentMethods';
import { isToggleActive } from '../components/featureToggle/toggles';
import MyCare from './MyCare';
import RegisterKitAdditionalBiomarkers from './registerKit/RegisterKitAdditionalBiomarkers';
import BigQueryBackfill from './bigQueryBackfill/BigQueryBackfill';
import orderVitamins from './orderVitamins';
import VitaminsOrderConfirmation from './orderVitamins/VitaminsOrderConfirmation';
import SubscribedContinueVits from './subscribedLogin/SubscribedContinueVits';
import MemberDrugSavingCard from './MemberDrugSavingCard';
import TmpTest from './TmpTest';
import DeleteMobileUser from './DeleteMobileUser';
import ChangeStripeId from './ChangeStripeId';
import BookConsultation from './bookConsultation/BookConsultation';
import MobileSymptomTrackersUnithroid from './MobileSymptomTrackersUnithroid';
import UploadLabResultsSuccess from './UploadLabResultsSuccess';
import CompleteProfile from './completeProfileFromMobile/CompleteProfile';
import ConfirmModal from '../components/ConfirmModal';
import MergeAccountsModal from '../components/mergeAccounts/MergeAccountsModal';
import CommunityTerms from './CommunityTerms';
import AdminTestNotifications from './AdminTestNotifications';
import AdminPasswordChange from './AdminPasswordChange';
import AdminGenerateOtp from './AdminGenerateOtp';
import LandingAdmin from './LandingAdmin';
import AdminHamburgerMenu from '../components/admin/hamburgerMenu/AdminHamburgerMenu';
import AdminViewMyLogs from './AdminViewMyLogs';
import AdminViewAdminLogs from './AdminViewAdminLogs';
import AdminSendMobileNotifications from './AdminSendMobileNotifications';
import ChangeHelpscoutId from './ChangeHelpscoutId';
import { MyInsurances } from './MyInsurances';
import AddNewInsurance from './myInsurances/AddNewInsurance';
import AdminBatchCreateSlots from './AdminBatchCreateSlots';
import AdminRunPr from './AdminRunPr';
import VisitVisio from './visitVisio/VisitVisio';
import CreateProviderUser from './CreateProviderUser';
import AsyncPostRegister from './asyncRegister/AsyncPostRegister';
import AdminResetUserWeek from './AdminResetUserWeek';
import CollapsibleNavLinkSection from '../components/CollapsibleNavLinkSection';
import doctorIcon from '../static/doctorIcon.png';
import nutritionistIcon from '../static/getSupportNutritionist.png';
import kitIcon from '../static/kitIcon.png';
import computerIcon from '../static/Computer.png';
import refillIcon from '../static/refillIcon.png';
import guidesIcon from '../static/reportIcon.png';
import communityIcon from '../static/shareImage.png';
import articlesIcon from '../static/refillIcon.png';
import recipesIcon from '../static/AdvocadoSmall.png';
import inviteFriendsIcon from '../static/nutritionistDashIcon.png';
import ViewArticle from './ViewArticle';
import ViewArticles from './ViewArticles';
import ViewRecipe from './ViewRecipe';
import ViewRecipes from './ViewRecipes';
import SpeakerSeries from './SpeakerSeries';
import ThyroidGuides from './ThyroidGuides';
import SpeakerSeriesIcon from '../static/icon_play.png';
import ongoingAdvice from '../static/ongoingAdvice.png';
import getSupportNutritionist from '../static/getSupportNutritionist.png';
import { Skeleton } from '../components/loadingSkeleton/Skeleton';
import moment from 'moment';
import { CleanDom } from '../utils/domCleanup';
import AdminPresetPlans from './AdminPresetPlans';
import AdminPresetPlan from './AdminPresetPlan';
import AdminWorkouts from './AdminWorkouts';
import RemapPwn from './RemapPwn';
import AdminB2BManagement from './AdminB2BManagement';
import EligibilityConfirmation from './EligibilityConfirmation';
import MyEligibility from './MyEligibility';
import SessionTimeout from '../components/SessionTimeout';
import AdminCareManagers from './adminCareManagers';
import RemapMobileUserAssociatedUser from './RemapMobileUserAssociatedUser';
import AdminSearchPatient from './adminSearchPatient';
import AdminMobileContactInfo from './AdminMobileContactInfo';
import TopHeaderContent from './dashboard/TopHeaderContent';
import YearlyReview from './YearlyReview/YearlyReview';
import SubscribedContinueInsurance from './selectPlan/SubscribedContinueInsurance';
import ChangeInsuranceMemberInsurance from './myInsurances/ChangeInsuranceMemberInsurance';
import SubscribedConfirm from './subscribedLogin/SubscribedConfirm';
import AdminBulkSetSurveyFlag from './AdminBulkSetSurveyFlag';
import AdminReorderPhysicianConvo from './adminReorderPhysicianConvo/AdminReorderPhysicianConvo';
import AdminIdentifyDups from './AdminIdentifyDups';
import CreateHealthCoachUser from './CreateHealthCoachUser';
import AdminHealthCoaches from './AdminHealthCoaches';
import HealthCoachFormBuilderWrap from './adminHealthCoachFormsTemplate/HealtCoachFormBuilder';
import HealthCoachFormsList from './adminHealthCoachFormsTemplate/HealthCoachFormsList';
import BaselineOutroSummary from './baselineSurvey/BaselineOutroSummary';
import LabResults2 from './labResults2/LabResults2';
import StandaloneLabDetail from './StandaloneLabDetail';
import ConsultationsV3 from './ConsultationsV3';
import BookConsultationNoHypo from './bookConsultation/BookConsultationNoHypo';
import LabOrders from './LabOrders';
import ScheduleSplit from './bookConsultation/ScheduleSplit';
import ScheduleMeno from './ScheduleMeno';
import BookConsultationMeno from './bookConsultation/BookConsultationMeno';
import AdminBannerFilterBuilder from './AdminBannerFilterBuilder';
import AdminBannerFilterList from './AdminBannerFilterList';
import AdminOtpValidities from './AdminOtpValidities';
import ScheduleWeightLoss from './ScheduleWeightLoss';
import smartIntake from './smartIntake';
import theme from '../styles/theme';
import AdminGetRecommendationSummaryData from './AdminGetRecommendationSummaryData';
import ScheduleBridgeWL from './ScheduleBridgeWL';
import ScheduleBridgeMeno from './ScheduleBridgeMeno';
import AdminBridge from './adminBridge';
import { AdminDepartments } from './AdminDeparments';
import { removeRetellWidget } from '../utils/retellWidget';
import TransformAppointmentToBridge from './TransformAppointmentToBridge';
import GutReset from './GutReset';
import UploadGILabResultsPage from './UploadGILabResults';
import ScheduleNutritionistGi from './ScheduleNutritionistGi';
import { AdminViewProviderCalendar } from './AdminViewProviderCalendar';
import { AdminRegionEdits } from './AdminRegions';
import { ActivateSmsLoginFeature } from './smsLogin/ActivateSmsLoginFeature';
import MyPrivacy from './MyPrivacy';
import myRx from './myRx';
import PalomaRxProducts from './PalomaRxProducts';
import PalomaRxProductDetails from './PalomaRxProductDetails';
import AdminSc from './adminSc';
import AdminGetReset from './AdminGetReset';
import MyRxResume from './myRxResume';
import MySubscriptionRefund from './MySubscriptionRefund';
// import { useHeader } from '../lib/useHeader';
// import ScheduleNoHypo from './ScheduleNoHypo';

const Container = styled(Div100vh)`
  display: flex;
  flex-direction: column;
  /* height: 100vh;
  max-height: 100vh; */
`;

const Outlet = styled(Flex)`
  &.overflow {
    overflow: auto;
  }
  &.centerContent {
    @media screen and (min-width: 1200px) {
      width: 1200px;
      max-width: 100vw;
      margin: 0 auto;
    }
  }
`;

const Header = styled(Flex)`
  /* height: 80px; */
  min-height: 80px;
  position: fixed;
  display: flex;
  flex-direction: column;
  background: #fdf5f2;
  width: 100%;
  box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.08);
  z-index: 10;
  max-width: 100vw;
`;

const HeaderSub = styled(Flex)`
  max-width: 100vw;
  width: 100%;
  @media screen and (min-width: 1200px) {
    padding-left: 30px;
  }
`;

const HeaderContent = styled(Flex)`
  height: 80px;
  max-height: 80px;
  width: 100vw;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
`;

const HeaderMenu = styled(Flex)`
  border-left: none;
  /* position: absolute; */
  right: 0;

  @media screen and (min-width: 52em) {
    display: flex;
    min-width: 100px;
  }
`;

const DesktopOnly = styled(Flex)`
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const NavLink = styled(RouterNavLink)`
  color: #344f79;
  stroke: #344f79;
  fill: #344f79;
  text-decoration: none;
  font-size: 16px;
  border-radius: 5px;
  padding: 4px 14px;
  margin-left: 28px;
  margin-right: 28px;
  font-weight: 300;
  /* margin-bottom: 20px; */

  @media screen and (max-width: 52em) {
    margin-bottom: 0;
  }
  @media screen and (max-width: 480px) {
    color: #344f79;
    /* padding: 10px 30px; */
  }
  &.active {
    background-color: #7992b3;
    color: white;
    stroke: white;
    fill: white;
    font-weight: 600;
    @media screen and (max-width: 480px) {
      color: white;
    }
  }
  &:hover {
    background-color: rgba(121, 146, 179, 0.25);
  }
`;

const FakeNavLink = styled(Text)`
  color: #344f79;
  text-decoration: none;
  font-size: 16px;
  font-weight: 300;
  border-radius: 5px;
  padding: 4px 14px;
  margin-left: 28px;
  margin-right: 28px;
  cursor: pointer;
  /* margin-bottom: 20px; */

  @media screen and (max-width: 52em) {
    margin-bottom: 0;
  }
  @media screen and (max-width: 480px) {
    color: #344f79;
    /* padding: 10px 30px; */
  }
  &:hover {
    background-color: rgba(121, 146, 179, 0.25);
  }
`;

const A = styled.a`
  display: flex;
  text-decoration: none;

  &:visited {
    color: #344f79;
  }
`;

const NavLinkSub = styled(RouterNavLink)`
  color: #344f79;
  text-decoration: none;
  font-size: 16px;
  font-weight: 300;
  border-radius: 5px;
  padding: 4px 14px;
  margin-left: 28px;
  margin-right: 28px;
  @media screen and (max-width: 480px) {
    color: #344f79;
  }
  &.active {
    background-color: #7992b3 !important;
    color: white;
    @media screen and (max-width: 480px) {
      color: white;
    }
  }
  &:hover {
    background-color: rgba(121, 146, 179, 0.25);
  }
`;

const FakeNavLinkSub = styled(Flex)`
  color: #344f79;
  text-decoration: none;
  font-size: 16px;
  font-weight: 300;
  border-radius: 5px;
  padding: 4px 14px;
  margin-left: 28px;
  margin-right: 28px;
  cursor: pointer;
  @media screen and (max-width: 480px) {
    color: #344f79;
  }

  &:hover {
    background-color: rgba(121, 146, 179, 0.25);
  }
`;

const NavButton = styled.button`
  display: block;
  position: absolute;
  top: 20px;
  left: 16px;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  background: transparent;
  border: 0;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const SHOW_SHADOW_PAGES = [];
const MAXED_UP_WIDTH_PAGES = ['/consultations-nutritionist', '/register-kit', '/thyroid-guides', '/articles', '/recipes', '/speaker-series', '/chat-care', '/account', '/my-care'];

// const HeaderContentWrap = () => {
//   const { headerContent } = useHeader();
//   if (!!headerContent) {
//     return <>{headerContent}</>;
//   }

//   return null;
// };
class Dashboard extends Component {
  state = {
    isSidebarOpen: false,
    isAccountOpen: false,
    isExitingImpersonation: false,
    isLabsSectionOpened: true,
    isResourcesSectionOpened: true,
    isMessagesSectionOpened: true,
    showBoxShadow: false,
    centerColumn: false,
  };

  profileRef = React.createRef();

  componentDidMount() {
    if (this.props.location.pathname.indexOf('purchase') < 0) {
      if (this.props.location.pathname.indexOf('/rx-products/EMBER') < 0 && this.props.location.pathname.indexOf('/my-rx') < 0) {
        // console.log('00 ',this.props.location.pathname)
        this.props.analytics.page();
      } else {
        // console.log('01 ',this.props.location.pathname)
      }
      // this.props.analytics.page();
    }
    if (this.props.session.isMember || this.props.session.isPausedMembership) {
      // if (window.Beacon) {
      //   window.Beacon('destroy');
      // }
      removeRetellWidget();
    }
    this.setShowShadow();
    this.setCenterColumn();
    CleanDom();
  }

  setShowShadow = () => {
    const currentPage = this.props.location.pathname;
    const { showBoxShadow } = this.state;
    for (let index = 0; index < SHOW_SHADOW_PAGES.length; index++) {
      const element = SHOW_SHADOW_PAGES[index];
      if (currentPage.indexOf(element) > -1) {
        if (!showBoxShadow) {
          this.setState({
            showBoxShadow: true,
          });
        }
        return;
      }
    }
    if (!!showBoxShadow) {
      this.setState({
        showBoxShadow: false,
      });
    }
  };

  setCenterColumn = () => {
    const currentPage = this.props.location.pathname;
    const { centerColumn } = this.state;
    for (let index = 0; index < MAXED_UP_WIDTH_PAGES.length; index++) {
      const element = MAXED_UP_WIDTH_PAGES[index];
      if (currentPage.indexOf(element) > -1) {
        if (!centerColumn) {
          this.setState({
            centerColumn: true,
          });
        }
        return;
      }
    }
    // console.log({ currentPage });
    if (currentPage === '/') {
      this.setState({
        centerColumn: true,
      });
      return;
    }
    if (!!centerColumn) {
      this.setState({
        centerColumn: false,
      });
    }
  };

  componentDidUpdate(prevProps) {
    const currentPage = this.props.location.pathname;
    const prevPage = prevProps.location.pathname;
    if (currentPage !== prevPage) {
      // console.log({ currentPage });
      this.setShowShadow();
      this.setCenterColumn();
      window.scroll(0, 0);
      if (currentPage.indexOf('purchase') < 0) {
        if (currentPage.indexOf('/rx-products/EMBER') < 0 && currentPage.indexOf('/my-rx') < 0) {
          // console.log('00 ',this.props.location.pathname)
          this.props.analytics.page();
        } else {
          // console.log('01 ',this.props.location.pathname)
        }
        // if (currentPage.indexOf('rx-products') < 0) {
        //   console.log('00 ', currentPage);
        //   this.props.analytics.page();
        // } else {
        //   console.log('01 ', currentPage);
        // }
      }
      CleanDom();
    }

    if (prevProps.session.isMember !== this.props.session.isMember || prevProps.session.isPausedMembership !==this.props.session.isPausedMembership) {
      if (this.props.session.isMember || this.props.session.isPausedMembership) {
        removeRetellWidget();
        // if (window.Beacon) {
        //   window.Beacon('destroy');
        // }
      }
    }
  }

  toggleMenu = () => {
    if (this.profileRef && this.profileRef.current) {
      try {
        this.profileRef.current.forceClose();
      } catch {
        try {
          this.profileRef.current.wrappedInstance.forceClose();
        } catch (error) {}
      }
    }
    if (!this.state.isSidebarOpen) {
      removeRetellWidget();
      // if (window.Beacon) {
      //   window.Beacon('destroy');
      // }
    } else {
      // if (window.Beacon && (!this.props.session || !this.props.session.isMember)) {
      //   window.Beacon('init', '828e0d09-171b-4d1e-9d3c-dc4f59c81115');
      // }
    }
    this.setState({ isSidebarOpen: !this.state.isSidebarOpen });
  };

  handleSidebar = () => {
    this.setState({ isSidebarOpen: !this.state.isSidebarOpen });
  };

  handleAccount = () => {
    if (isMobile) {
      if (window.Beacon) {
        window.Beacon('destroy');
      }
    }
    this.setState({
      isAccountOpen: true,
      isSidebarOpen: false,
    });
  };

  handleAccountClose = () => {
    if (isMobile) {
      // if (window.Beacon && !this.props.session.isMember) {
      //   // console.log('window.onbeforeunload Beacon found');
      //   window.Beacon('init', '828e0d09-171b-4d1e-9d3c-dc4f59c81115');
      // }
    }
    this.setState({
      isAccountOpen: false,
      isSidebarOpen: false,
    });
  };

  handleAccountHover = () => {
    this.setState({ isAccountOpen: true });
  };

  handleAccountLeave = () => {
    this.setState({ isAccountOpen: false });
  };

  exitImpersonationMode = async () => {
    const { client, refetch } = this.props;
    this.setState({
      isExitingImpersonation: true,
    });
    const initialToken = localStorage.getItem('initialToken');
    // console.log('Initial Tok', initialToken);
    localStorage.setItem('token', initialToken);
    localStorage.setItem('initialToken', '');

    if (initialToken === 'aa00') {
      window.close();
    }
    await client.clearStore();
    await refetch();
    // await client.query({
    //   query: CURRENT_USER,
    //   // refetchQueries: [{ query: ATHENA_CARD }, { query: APPOINTMENTS }, { query: LABS }, { query: GET_USER_PCP }],
    //   // fetchPolicy: 'network-only',
    //   // awaitRefetchQueries: true,
    // });
    this.setState(
      {
        isExitingImpersonation: false,
      },
      () => this.props.history.push('/'),
    );
  };

  onCommunityClick = async () => {
    const { client, history } = this.props;

    const circleSo = await client.mutate({
      mutation: GENERATE_CIRCLE_SO_CALLBACK,
    });

    if (circleSo && circleSo.data && circleSo.data.generateCircleSoCallback) {
      if (!!circleSo.data.generateCircleSoCallback.callback) {
        this.props.analytics.track('Open community');
        window.open(circleSo.data.generateCircleSoCallback.callback, '_blank');
      } else if (!!circleSo.data.generateCircleSoCallback.mustAcceptTerms) {
        history.push({
          pathname: '/community-terms',
          state: { sameWindow: false },
        });
      }
    }
  };

  render() {
    const currentPage = this.props.location.pathname;
    const { isSidebarOpen, isAccountOpen, isExitingImpersonation, showBoxShadow, centerColumn } = this.state;
    const {
      session: { eligibility, intakeStatus, isLab, adm, email, isDiagnosed, diagnoseFull, isMember, isPausedMembership, mustCompleteProfile, mustMergeAccount, perpetuousPhysicianConversationId, b2b },
    } = this.props;

    // console.log({
    //   canBookAsync: eligibility.canBookAsync,
    //   t: isToggleActive('RX_VISITS'),
    // });
    // console.log({ th: this.props });
    const t = isToggleActive('PERSONAL_ADMIN');

    if (!!mustCompleteProfile) {
      return <CompleteProfile />;
    }

    if (isExitingImpersonation) {
      return <LoadingScreen text="Exiting Impersonation Mode" />;
    }
    // console.log('Eligibility', {
    //   eligibility,
    //   s: this.props.session,
    // });
    const isSchedulePage =
      this.props.location && this.props.location.pathname && this.props.location.pathname.startsWith('/schedule') && this.props.location.pathname.indexOf('/schedule-nutritionist-gi') < 0;
    const isMobileCourseEditor = this.props.location && this.props.location.pathname && this.props.location.pathname.startsWith('/course-editor');
    const isHealthCoachFormEditor = this.props.location && this.props.location.pathname && this.props.location.pathname.startsWith('/hc-template-builder');
    let isRxProductPage = false
    if(this.props.location && this.props.location.pathname){
      isRxProductPage = /^\/rx-products\/.+/.test(this.props.location.pathname);
    }
      // this.props.location && this.props.location.pathname && this.props.location.pathname.startsWith('/rx-products');
    // console.log({ adm });
    if (adm && adm.passwordExpired) {
      // || (adm.daysBeforePasswordExpires>0 && adm.daysBeforePasswordExpires<=3)){
      return (
        <Container flex={1}>
          <AdminPasswordChange />
        </Container>
      );
    }
    if (isLab) {
      return (
        <Container flex={1}>
          <Header flex={1}>
            <NavButton alignItems="center" onClick={this.toggleMenu}>
              <Menu />
            </NavButton>
            <Flex flex={1} px="30px" alignItems="center" justifyContent={['center', 'center', 'flex-start']}>
              <Link to="/">
                <LogoHeader />
              </Link>
            </Flex>
            <HeaderMenu pl={3}>
              <HeaderAccount
                session={this.props.session}
                ref={this.profileRef}
                open={isAccountOpen}
                onClick={() => {
                  this.handleAccount();
                }}
                onClose={this.handleAccountClose}
                onHover={this.handleAccountHover}
                onLeave={this.handleAccountLeave}
              />
            </HeaderMenu>
          </Header>
          <Flex flex={1} bg="#FDF5F2">
            <Flex flex={1} mt="80px">
              <Switch>
                <Route exact path="/" component={LabScan} {...this.props} />
                <Route path="/requisition/:id" component={ViewRequisitionForm} {...this.props} />
                <Route path="*" component={LabScan} {...this.props} />
              </Switch>
            </Flex>
          </Flex>
        </Container>
      );
    }

    const initTok = localStorage.getItem('initialToken');

    const globalEligibility = eligibility.status !== 'no_service' || eligibility.canBookNutritionist;

    const visitsEligibility =
      ((eligibility.consultation || eligibility.canBookNutritionist) &&
        // eligibility.status !== 'new_patient' &&
        (isDiagnosed || (diagnoseFull && diagnoseFull.hasHashi) || (diagnoseFull && (diagnoseFull.hasAppointment || (diagnoseFull && diagnoseFull.hasAppointmentNutritionist))))) ||
      eligibility.canBookPerimenopause ||
      eligibility.canBookPostmenopause ||
      eligibility.canBookWeightLoss;

    const doctorVisit =
      (eligibility.consultation &&
        intakeStatus !== 'disqualified' &&
        (isDiagnosed || (diagnoseFull && diagnoseFull.hasAppointment)) &&
        (eligibility.status !== 'new_patient' || (diagnoseFull && diagnoseFull.hasAppointment))) ||
      eligibility.canBookPerimenopause ||
      eligibility.canBookPostmenopause ||
      eligibility.canBookWeightLoss;

    const nutritionistVisit = eligibility.canBookNutritionist && (isDiagnosed || (diagnoseFull && (diagnoseFull.hasHashi || (diagnoseFull && diagnoseFull.hasAppointmentNutritionist))));
    // console.log({visitsEligibility, doctorVisit})

    const displayB2BnotVerified = !!b2b && !!b2b.pendingApproval;
    return (
      <Container id="cont" flex={1}>
        {!window.ReactNativeWebView && (
          <Header flex={1} id="appHead">
            {!!displayB2BnotVerified && (
              <Flex style={{ background: theme.color.pink, color: 'white', minHeight: '40px', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ color: 'white', textAlign: 'center' }}>
                  Your eligibility is being verified. Some features and benefits may be limited. We’ll update you soon, or please reach out <a href="mailto:contact@palomahealth.com">here</a>.
                </Text>
              </Flex>
            )}
            <HeaderSub>
              <HeaderContent>
                <NavButton alignItems="center" onClick={this.toggleMenu}>
                  <Menu />
                </NavButton>
                <Flex flex={[1, 1, 0]} px="30px" mr={['-46px', '', '']} alignItems="center" justifyContent={['center', 'center', 'flex-start']}>
                  <Link to="/">
                    <LogoHeader height="40px" />
                  </Link>
                </Flex>
                <Flex flex={[0, 0, 1]} justifyContent="center" alignItems={'center'}>
                  <TopHeaderContent />
                  {/* <HeaderContentWrap /> */}
                </Flex>
                <HeaderMenu pl={3}>
                  <DesktopOnly>
                    {currentPage.indexOf('/schedule/') < 0 && (
                      <Flex alignItems="center" mr="16px" pr="16px" style={{ borderRight: '1px solid #e0e0e0' }}>
                        <A href="tel:434-248-7508" style={{ marginLeft: '24px' }}>
                          <div
                            style={{
                              width: '30px',
                              transform: 'scaleX(-1)',
                              marginRight: '12px',
                            }}
                          >
                            <FontAwesomeIcon size="1x" color="#344f79" icon={faPhone} />
                          </div>
                          <Text style={{ fontWeight: 500 }}>434-248-7508</Text>
                        </A>
                      </Flex>
                    )}
                  </DesktopOnly>
                  <HeaderAccount
                    session={this.props.session}
                    ref={this.profileRef}
                    onClick={() => {
                      this.handleAccount();
                    }}
                    onClose={this.handleAccountClose}
                    onHover={this.handleAccountHover}
                    onLeave={this.handleAccountLeave}
                    open={isAccountOpen}
                  />
                </HeaderMenu>

                {initTok !== null &&
                  initTok !== '' && (
                    <div
                      style={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: 0,
                        height: '26px',
                        background: 'red',
                      }}
                      id="impersonateBanner"
                    >
                      <div
                        style={{
                          color: 'white',
                          fontWeight: '500',
                          textAlign: 'center',
                        }}
                      >
                        Impersonating Mode Active
                        {' - '}
                        <span style={{ textDecoration: 'underline' }} onClick={() => this.exitImpersonationMode()}>
                          Exit
                        </span>
                      </div>
                    </div>
                  )}
              </HeaderContent>
            </HeaderSub>
            {/* </div> */}
          </Header>
        )}
        <Outlet
          id="toMaxUp"
          className={
            currentPage.indexOf('/pickDoctor') > -1 || currentPage.indexOf('/hc-template-builder') > -1
              ? ''
              : currentPage.indexOf('/schedule') > -1 && currentPage.indexOf('/schedule-nutritionist-gi') < 0 && currentPage.indexOf('/payment') > -1
                ? 'overflow'
                : 'centerContent'
          }
          flex={1}
          bg="#FDF5F2"
        >
          {(!t ? (
            window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email
          ) : (
            !!adm
          )) ? (
            <AdminHamburgerMenu open={isSidebarOpen} forceClose={!isSchedulePage && !isMobileCourseEditor && !isHealthCoachFormEditor && !isRxProductPage} handleSidebar={this.handleSidebar} />
          ) : (
            <Sidebar displayB2BnotVerified={displayB2BnotVerified} showShadow={showBoxShadow} open={isSidebarOpen} forceClose={!isSchedulePage && !isMobileCourseEditor && !isRxProductPage}>
              <NavLink id="link_yourDashboard" exact to="/" onClick={this.handleSidebar}>
                <Flex flexDirection={'row'} alignItems="center" style={{ minHeight: '29px' }}>
                  <svg width="12" height="12" viewBox="0 0 12 12" style={{ marginRight: '8px' }} fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_366_636)">
                      <path d="M4.5 7.5V11.25H1.5V4.5L6 0.75L10.5 4.5V11.25H7.5V7.5H4.5Z" stroke="inherit" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_366_636">
                        <rect width="12" height="12" fill="inherit" />
                      </clipPath>
                    </defs>
                  </svg>
                  Your Dashboard
                </Flex>
              </NavLink>
              {!!globalEligibility && (
                <Fragment>
                  {!!visitsEligibility ? (
                    (!!doctorVisit || !!nutritionistVisit) && (
                      <CollapsibleNavLinkSection text="Video Visits">
                        <Fragment>
                          {!!doctorVisit ? (
                            <NavLinkSub id="link_consultationsDoctor" to="/consultations" onClick={this.handleSidebar}>
                              <Flex flexDirection={'row'} alignItems="center">
                                <Image src={doctorIcon} width="29px" height="29px" mr="10px" />
                                Clinician
                              </Flex>
                            </NavLinkSub>
                          ) : (
                            <Query query={APPOINTMENTS}>
                              {({ data: dataAppointments, loading: loadingAppointments }) => {
                                let pastAppointment;
                                if (!!loadingAppointments) return null;
                                if (dataAppointments && dataAppointments.appointments) {
                                  const { appointments } = dataAppointments;
                                  pastAppointment = appointments
                                    .sort((a, b) => {
                                      const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                                      const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                                      if (ma.isAfter(mb)) return -1;
                                      return 1;
                                    })
                                    .filter((item) => {
                                      if (
                                        item.status &&
                                        item.status !== 'x' &&
                                        item.status !== 'f' &&
                                        item.status !== 'o' &&
                                        item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_APPOINTMENT_TYPE_ID &&
                                        item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID
                                      ) {
                                        const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                                        return dt.isBefore(moment(), 'minute');
                                      }
                                      return false;
                                    });
                                }
                                if (!pastAppointment || pastAppointment.length < 1) return null;

                                return (
                                  <>
                                    {pastAppointment.filter(
                                      (item) =>
                                        item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_APPOINTMENT_TYPE_ID &&
                                        item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID &&
                                        item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_NEW_NUTRITIONIST_30,
                                    ).length > 0 && (
                                      <NavLinkSub id="link_consultationsDoctor" to="/consultations" onClick={this.handleSidebar}>
                                        <Flex flexDirection={'row'} alignItems="center">
                                          <Image src={doctorIcon} width="29px" height="29px" mr="10px" />
                                          Clinician
                                        </Flex>
                                      </NavLinkSub>
                                    )}
                                  </>
                                );
                              }}
                            </Query>
                          )}
                          {!!nutritionistVisit ? (
                            <NavLinkSub
                              id="link_consultationsNutritionist"
                              to="/consultations-nutritionist"
                              onClick={this.handleSidebar}
                              style={{
                                marginBottom: '20px !important',
                              }}
                            >
                              <Flex flexDirection={'row'} alignItems="center">
                                <Image src={nutritionistIcon} width="29px" height="29px" mr={2} />
                                Nutritionist
                              </Flex>
                            </NavLinkSub>
                          ) : null}
                        </Fragment>
                      </CollapsibleNavLinkSection>
                    )
                  ) : (
                    <Query query={APPOINTMENTS}>
                      {({ data: dataAppointments, loading: loadingAppointments }) => {
                        let pastAppointment;
                        if (!!loadingAppointments) return null;
                        if (dataAppointments && dataAppointments.appointments) {
                          const { appointments } = dataAppointments;
                          pastAppointment = appointments
                            .sort((a, b) => {
                              const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                              const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                              if (ma.isAfter(mb)) return -1;
                              return 1;
                            })
                            .filter((item) => {
                              if (
                                item.status &&
                                item.status !== 'x' &&
                                item.status !== 'f' &&
                                item.status !== 'o' &&
                                item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_APPOINTMENT_TYPE_ID &&
                                item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID
                              ) {
                                const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                                return dt.isBefore(moment(), 'minute');
                              }
                              return false;
                            });
                        }
                        if (!pastAppointment || pastAppointment.length < 1) return null;

                        return (
                          <>
                            {pastAppointment.filter(
                              (item) =>
                                item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_APPOINTMENT_TYPE_ID &&
                                item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID &&
                                item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_NEW_NUTRITIONIST_30,
                            ).length > 0 && (
                              <NavLinkSub id="link_consultationsDoctor" to="/consultations" onClick={this.handleSidebar}>
                                <Flex flexDirection={'row'} alignItems="center">
                                  <Image src={doctorIcon} width="29px" height="29px" mr="10px" />
                                  Clinician
                                </Flex>
                              </NavLinkSub>
                            )}
                            {pastAppointment.filter((item) => item.appointmentTypeId === window._env_.REACT_APP_ATHENA_NEW_NUTRITIONIST_30).length > 0 && (
                              <NavLinkSub
                                id="link_consultationsNutritionist"
                                to="/consultations-nutritionist"
                                onClick={this.handleSidebar}
                                style={{
                                  marginBottom: '20px !important',
                                }}
                              >
                                <Flex flexDirection={'row'} alignItems="center">
                                  <Image src={nutritionistIcon} width="29px" height="29px" mr={2} />
                                  Nutritionist
                                </Flex>
                              </NavLinkSub>
                            )}
                          </>
                        );
                      }}
                    </Query>
                  )}

                  {eligibility.canBookAsync &&
                    isToggleActive('RX_VISITS') && (
                      <CollapsibleNavLinkSection text="Custom Rx">
                        <NavLinkSub id="link_rxProducts" to="/rx-products" onClick={this.handleSidebar}>
                          <Flex flexDirection={'row'} alignItems="center">
                            <Image src={kitIcon} width="29px" height="29px" mr={2} />
                            All Products
                          </Flex>
                        </NavLinkSub>
                        <NavLinkSub id="link_myRx" to="/my-rx" onClick={this.handleSidebar}>
                          <Flex flexDirection={'row'} alignItems="center">
                            <Image src={computerIcon} width="29px" height="29px" mr={2} />
                            My Rx
                          </Flex>
                        </NavLinkSub>
                      </CollapsibleNavLinkSection>
                    )}

                  {eligibility.lab ? (
                    <CollapsibleNavLinkSection text="Labs">
                      <Fragment>
                        <NavLinkSub id="link_registerKit" to="/register-kit" onClick={this.handleSidebar}>
                          <Flex flexDirection={'row'} alignItems="center">
                            <Image src={kitIcon} width="29px" height="29px" mr={2} />
                            Register Your Kit
                          </Flex>
                        </NavLinkSub>
                        <NavLinkSub id="link_labs" to="/labs" onClick={this.handleSidebar}>
                          <Flex flexDirection={'row'} alignItems="center">
                            <Image src={computerIcon} width="29px" height="29px" mr={2} />
                            Labs & Kits
                          </Flex>
                        </NavLinkSub>
                        {isToggleActive('LABORDERS') && (
                          <Query query={GET_LAB_ORDERS_LIST}>
                            {({ data: dataLabOrders, loading: loadingLabOrders }) => {
                              if (!!loadingLabOrders) {
                                return (
                                  <FakeNavLink id="link_registerKit" onClick={() => {}}>
                                    <Flex flexDirection={'row'} alignItems="center">
                                      <Image src={ongoingAdvice} width="29px" height="29px" mr={2} />
                                      <Skeleton height="14px" width="75px" />
                                    </Flex>
                                  </FakeNavLink>
                                );
                              }
                              if (!dataLabOrders || !dataLabOrders.getLabOrdersReady || dataLabOrders.getLabOrdersReady.length < 1) {
                                return null;
                              }
                              return (
                                <NavLinkSub id="link_labs" to="/lab-orders" onClick={this.handleSidebar}>
                                  <Flex flexDirection={'row'} alignItems="center">
                                    <Image src={refillIcon} width="29px" height="29px" mr={2} />
                                    Your Lab Orders
                                  </Flex>
                                </NavLinkSub>
                              );
                            }}
                          </Query>
                        )}
                      </Fragment>
                    </CollapsibleNavLinkSection>
                  ) : (
                    <>
                      {isToggleActive('LABORDERS') && (
                        <Query query={GET_LAB_ORDERS_LIST}>
                          {({ data: dataLabOrders, loading: loadingLabOrders }) => {
                            if (!!loadingLabOrders) {
                              return (
                                <FakeNavLink id="link_registerKit" onClick={() => {}}>
                                  <Flex flexDirection={'row'} alignItems="center">
                                    <Image src={ongoingAdvice} width="29px" height="29px" mr={2} />
                                    <Skeleton height="14px" width="75px" />
                                  </Flex>
                                </FakeNavLink>
                              );
                            }
                            if (!dataLabOrders || !dataLabOrders.getLabOrdersReady || dataLabOrders.getLabOrdersReady.length < 1) {
                              return null;
                            }
                            return (
                              <CollapsibleNavLinkSection text="Labs">
                                <NavLinkSub id="link_labs" to="/lab-orders" onClick={this.handleSidebar}>
                                  <Flex flexDirection={'row'} alignItems="center">
                                    <Image src={refillIcon} width="29px" height="29px" mr={2} />
                                    Your Lab Orders
                                  </Flex>
                                </NavLinkSub>
                              </CollapsibleNavLinkSection>
                            );
                          }}
                        </Query>
                      )}
                    </>
                  )}

                  <CollapsibleNavLinkSection text="Resources" defaultExpanded={false}>
                    <Fragment>
                      <NavLinkSub id="link_registerKit" to="/thyroid-guides" onClick={this.handleSidebar}>
                        <Flex flexDirection={'row'} alignItems="center">
                          <Image src={guidesIcon} width="29px" height="29px" mr={2} />
                          Thyroid Guides
                        </Flex>
                      </NavLinkSub>
                      <FakeNavLink id="link_labs" onClick={this.onCommunityClick}>
                        <Flex flexDirection={'row'} alignItems="center">
                          <Image src={communityIcon} width="29px" height="29px" mr={2} />
                          Community
                        </Flex>
                      </FakeNavLink>
                      <NavLinkSub id="link_labs" to="/articles" onClick={this.handleSidebar}>
                        <Flex flexDirection={'row'} alignItems="center">
                          <Image src={articlesIcon} width="29px" height="29px" mr={2} />
                          Articles
                        </Flex>
                      </NavLinkSub>
                      <NavLinkSub id="link_recipes" to="/recipes" onClick={this.handleSidebar}>
                        <Flex flexDirection={'row'} alignItems="center">
                          <Image src={recipesIcon} width="29px" height="29px" mr={2} />
                          Recipes
                        </Flex>
                      </NavLinkSub>
                      <NavLinkSub id="link_videos" to="/speaker-series" onClick={this.handleSidebar}>
                        <Flex flexDirection={'row'} alignItems="center" style={{ minHeight: '28px' }}>
                          <Image src={SpeakerSeriesIcon} width="20px" height="20px" mr={'18px'} />
                          Video Library
                        </Flex>
                      </NavLinkSub>
                      <FakeNavLinkSub
                        id="link_thyroidFinds"
                        onClick={() => {
                          window.open('https://thyroidfinds.palomahealth.com/', '_blank', 'noopener,noreferrer');
                        }}
                      >
                        <Flex flexDirection={'row'} alignItems="center">
                          {/* <Image src={getSupportNutritionist} width="29px" height="29px" mr={2} /> */}
                          <svg style={{ marginRight: '10px' }} width="22" viewBox="0 0 235 260" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_2118_2)">
                              <path d="M155.197 211.513H150.417V205.864H155.197V211.513Z" fill="#EB998B" />
                              <mask id="mask0_2118_2" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="-205" y="-99" width="628" height="458">
                                <path d="M-204.199 -98.666H423V358.667H-204.199V-98.666Z" fill="white" />
                              </mask>
                              <g mask="url(#mask0_2118_2)">
                                <path
                                  d="M155.327 209.24C156.899 209.759 172.294 211.67 173.074 213.129C173.113 213.202 173.149 213.276 173.181 213.352C173.833 214.896 172.555 216.582 170.88 216.5L147.316 215.351L150.62 209.24C150.62 209.24 149.831 211.645 151.78 211.477C153.728 211.309 155.327 209.24 155.327 209.24Z"
                                  fill="#445977"
                                />
                                <path d="M148.996 215.767L144.253 216.36L143.553 210.755L148.295 210.163L148.996 215.767Z" fill="#EB998B" />
                                <path
                                  d="M148.881 213.513C150.462 214.003 167.601 215.576 168.407 217.021C168.447 217.093 168.484 217.167 168.517 217.242C169.198 218.774 167.951 220.482 166.275 220.432L142.694 219.714L143.667 213.585C143.667 213.585 145.141 215.962 147.085 215.759C149.03 215.555 148.881 213.513 148.881 213.513Z"
                                  fill="#496187"
                                />
                                <path
                                  d="M76.4253 35.8671C77.077 39.7776 77.2942 43.5797 76.7513 46.6213C76.2077 49.6629 75.4476 58.3535 68.9299 58.3535C62.412 58.3535 58.1754 52.8133 57.6322 49.8801C57.0893 46.9473 58.1754 39.4519 59.2616 37.931C60.3481 36.4104 66.7573 33.4772 66.7573 33.4772L76.4253 35.8671Z"
                                  fill="#EBB6A7"
                                />
                                <path
                                  d="M99.1289 152.101C104.56 151.884 153.227 142.541 157.355 142.541C161.482 142.541 159.962 157.967 159.962 163.833C159.962 169.699 156.493 207.068 156.493 207.068L150.193 207.937L145.413 162.312L111.955 166.005L99.1289 152.101Z"
                                  fill="#3F526D"
                                />
                                <path
                                  d="M99.7807 152.97C100.432 152.753 145.623 145.366 149.099 145.366C152.575 145.366 154.53 146.235 154.096 162.313C153.661 178.389 151.054 210.544 151.054 210.544L142.364 211.413L137.801 166.875L116.292 169.917C116.292 169.917 111.296 169.047 104.343 161.878C97.3908 154.708 99.7807 152.97 99.7807 152.97Z"
                                  fill="#496187"
                                />
                                <path
                                  d="M55.17 52.2329C52.5577 52.2329 46.4794 42.9634 49.5213 33.983C49.5213 33.983 55.0975 23.5545 63.7878 23.8443C72.4785 24.134 79.1412 30.2898 78.1997 40.0662C75.882 40.3563 68.8574 39.7043 68.3504 39.6318C67.8434 39.5596 67.8434 36.8799 67.8434 36.8799L66.9023 38.8353L62.9914 38.4009C62.9914 38.4009 61.7602 41.6597 58.8633 42.0216C58.2116 41.4425 56.546 40.0662 54.6631 42.4561C54.3011 44.846 55.4598 46.005 56.039 45.86C56.6185 45.7153 56.4013 47.8154 56.4013 47.8154L55.8943 53.3916C55.8943 53.3916 55.3873 52.2329 55.17 52.2329Z"
                                  fill="#3A4E76"
                                />
                                <path
                                  d="M62.5214 26.9567C62.5214 31.1164 58.6954 34.4883 53.9758 34.4883C49.2561 34.4883 45.4302 31.1164 45.4302 26.9567C45.4302 22.7972 49.2561 19.425 53.9758 19.425C58.6954 19.425 62.5214 22.7972 62.5214 26.9567Z"
                                  fill="#3A4E76"
                                />
                                <path
                                  d="M68.9298 56.2885L67.3004 66.391C67.3004 66.391 64.4761 67.912 60.2392 65.3048C56.0027 62.6977 55.0253 60.6338 55.0253 60.6338C55.0253 60.6338 57.5844 46.4928 56.5459 46.0773C54.3732 45.2083 54.6993 42.2752 54.6993 42.2752C54.6993 42.2752 56.3287 40.4285 58.1753 41.189C60.022 41.9492 60.5652 41.9492 60.5652 41.9492"
                                  fill="#EBB6A7"
                                />
                                <path d="M68.7124 136.023L105.755 131.681L97.6433 152.61L68.7124 136.023Z" fill="#3E516D" />
                                <path d="M71.1023 136.24L106.081 130.375L97.9703 151.304L71.1023 136.24Z" fill="#496187" />
                                <path
                                  d="M63.3896 65.3055L78.9239 91.0508L69.4732 65.6316C69.4732 65.6316 68.1694 64.8711 66.3228 64.8711C64.4761 64.8711 63.3896 65.3055 63.3896 65.3055Z"
                                  fill="#EBB6A7"
                                />
                                <path
                                  d="M73.492 126.247C68.0605 126.029 70.2332 122.119 64.15 124.074C60.7827 125.156 58.7182 131.461 65.0189 134.72C71.3197 137.979 99.5633 140.151 101.736 141.02C103.909 141.889 108.146 137.616 104.56 134.72C98.9116 130.157 73.492 126.247 73.492 126.247Z"
                                  fill="#EBB6A7"
                                />
                                <path d="M150.982 112.995C150.33 112.995 111.875 116.688 111.875 116.688L97.7512 152.433L137.075 146.349L150.982 112.995Z" fill="#496187" />
                                <path
                                  d="M102.605 112.559C100.432 109.952 92.1764 113.863 93.2625 116.905C94.349 119.946 104.778 133.199 104.778 133.199L107.602 127.116L102.605 112.559Z"
                                  fill="#EBB6A7"
                                />
                              </g>
                            </g>
                            <defs>
                              <clipPath id="clip0_2118_2">
                                <rect width="235" height="260" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Thyroid Finds
                        </Flex>
                      </FakeNavLinkSub>
                    </Fragment>
                  </CollapsibleNavLinkSection>

                  <Query query={APPOINTMENTS}>
                    {({ data: dataAppointments, loading: loadingAppointments }) => {
                      let pastAppointment;
                      if (dataAppointments && dataAppointments.appointments) {
                        const { appointments } = dataAppointments;
                        pastAppointment = appointments
                          .sort((a, b) => {
                            const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                            const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                            if (ma.isAfter(mb)) return -1;
                            return 1;
                          })
                          .find((item) => {
                            if (
                              item.status &&
                              item.status !== 'x' &&
                              item.status !== 'f' &&
                              item.status !== 'o' &&
                              item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_APPOINTMENT_TYPE_ID &&
                              item.appointmentTypeId !== window._env_.REACT_APP_ATHENA_ASYNC_MEMBER_APPOINTMENT_TYPE_ID
                            ) {
                              const dt = moment(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm');
                              return dt.isBefore(moment(), 'minute');
                            }
                            return false;
                          });
                      }
                      if (!loadingAppointments && !pastAppointment && !isMember && !isPausedMembership) return null;
                      return (
                        <CollapsibleNavLinkSection text="Messages">
                          <Fragment>
                            {!loadingAppointments ? (
                              <>
                                {!!pastAppointment ? (
                                  <NavLinkSub
                                    id="link_registerKit"
                                    to={{
                                      pathname: `/consultations-communicator/${pastAppointment.id}`,
                                      state: { isDesktopForced: true },
                                    }}
                                    onClick={this.handleSidebar}
                                  >
                                    <Flex flexDirection={'row'} alignItems="center">
                                      <Image src={ongoingAdvice} width="29px" height="29px" mr={2} />
                                      Provider
                                    </Flex>
                                  </NavLinkSub>
                                ) : null}
                              </>
                            ) : (
                              <FakeNavLink id="link_registerKit" onClick={() => {}}>
                                <Flex flexDirection={'row'} alignItems="center">
                                  <Image src={ongoingAdvice} width="29px" height="29px" mr={2} />
                                  <Skeleton height="14px" width="75px" />
                                </Flex>
                              </FakeNavLink>
                            )}
                            {(isMember || isPausedMembership) && (
                              <NavLinkSub id="link_registerKit" to={`/chat-care`} onClick={this.handleSidebar}>
                                <Flex flexDirection={'row'} alignItems="center">
                                  <Image src={communityIcon} width="29px" height="29px" mr={2} />
                                  Care Manager
                                </Flex>
                              </NavLinkSub>
                            )}
                          </Fragment>
                        </CollapsibleNavLinkSection>
                      );
                    }}
                  </Query>

                  <NavLink id="link_yourDashboard" exact to="/invite-friends" onClick={this.handleSidebar} style={{ marginTop: '16px' }}>
                    <Flex flexDirection={'row'} alignItems="center" style={{ minHeight: '29px' }}>
                      <Image src={inviteFriendsIcon} width="29px" height="29px" mr={2} />
                      Invite Friends
                    </Flex>
                  </NavLink>
                  {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canChangeEmail) && (
                    <>
                      <NavLink to="/change-email" onClick={this.handleSidebar}>
                        Change Email
                      </NavLink>
                      {/* <FakeNavLink>Community</FakeNavLink> */}
                    </>
                  )}
                  {isToggleActive('GUTRESET') &&
                    !!eligibility &&
                    !!eligibility.canBookNutritionist && (
                      <CollapsibleNavLinkSection text="Programs">
                        <Fragment>
                          <NavLinkSub id="link_gutreset" to={`/programs/gut-reset`} onClick={this.handleSidebar}>
                            <Flex flexDirection={'row'} alignItems="center">
                              {/* <Image src={getSupportNutritionist} width="29px" height="29px" mr={2} /> */}
                              <svg style={{ marginRight: '10px' }} width="26" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_126_3253)">
                                  <path
                                    d="M14.4561 12.526C15.0964 12.526 15.7104 12.2717 16.1631 11.819M14.4561 12.526C13.8158 12.526 13.2018 12.2717 12.749 11.819M14.4561 12.526V14.3366M16.1631 11.819C16.6159 11.3662 16.8702 10.7522 16.8702 10.1119M16.1631 11.819L17.4433 13.0991M16.8702 10.1119C16.8702 9.47164 16.6159 8.8576 16.1631 8.40486M16.8702 10.1119H18.6808M16.1631 8.40486C15.7104 7.95212 15.0964 7.69778 14.4561 7.69778M16.1631 8.40486L17.4433 7.12381M14.4561 7.69778C13.8158 7.69778 13.2018 7.95212 12.749 8.40486M14.4561 7.69778V5.88718M12.749 8.40486C12.2963 8.8576 12.042 9.47164 12.042 10.1119M12.749 8.40486L11.4689 7.12381M12.042 10.1119C12.042 10.7522 12.2963 11.3662 12.749 11.819M12.042 10.1119H10.2314M12.749 11.819L11.4689 13.0991M14.0543 5.88718H14.8587M17.1589 6.83944L17.7286 7.40905M18.6808 9.70926V10.5137M17.7286 12.8148L17.1589 13.3835M14.8587 14.3366H14.0543M11.7532 13.3835L11.1845 12.8148M10.2314 10.5137V9.70926M11.1845 7.40905L11.7532 6.83944"
                                    stroke="#EBB6A7"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M9.39215 21.0068C9.44222 19.8919 9.68526 18.7941 10.1105 17.7622C13.7021 18.3579 19.9035 16.3577 21.7637 12.6382C24.2518 7.65778 19.9157 1.46678 14.19 2.42078C12.4751 2.71066 10.8772 3.47976 9.58086 4.63924C8.49467 3.61219 8.45032 3.22259 7.56328 1.43982M3.11679 1.43982C3.86548 3.95189 5.15891 6.26796 6.90496 8.22305C5.69094 10.7711 5.49353 13.5714 6.45014 15.422C5.51789 17.14 5.00254 19.053 4.94565 21.0068"
                                    stroke="#344F7A"
                                    strokeWidth="1"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_126_3253">
                                    <rect width="20.8715" height="20.8715" fill="white" transform="translate(2.36282 0.787598)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              Gut Reset
                            </Flex>
                          </NavLinkSub>

                          <FakeNavLinkSub
                            id="link_gutreset"
                            onClick={() => {
                              window.open('https://dna.palomahealth.co/', '_blank', 'noopener,noreferrer');
                            }}
                          >
                            <Flex flexDirection={'row'} alignItems="center">
                              {/* <Image src={getSupportNutritionist} width="29px" height="29px" mr={2} /> */}
                              <svg style={{ marginRight: '10px' }} width="22" viewBox="0 0 233 233" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M28.883 109.346C41.8254 96.4037 57.1524 93.7825 72.4613 93.7097C63.4871 96.786 56.8248 103.23 50.5083 112.295C33.8706 136.178 43.0086 172.93 48.9246 194.355C51.7279 204.512 54.6222 215.106 56.2787 225.719H26.5348C25.1877 218.674 23.1672 210.883 20.7462 202.128C12.4092 171.838 2.43384 135.795 28.883 109.346ZM212.407 30.8725C220.744 61.1625 230.21 95.4754 203.76 121.925C200.393 125.292 196.079 128.678 191.928 131.154C186.358 134.466 181.534 135.996 181.534 135.996C181.534 135.996 190.636 118.211 191.947 108.582C195.169 85.1178 190.418 61.1807 184.21 38.627C181.443 28.4879 178.531 17.8937 176.874 7.28125H206.618C207.984 14.3077 210.004 22.1168 212.407 30.8725Z"
                                  fill="#354E79"
                                />
                                <path
                                  d="M131.738 49.8917C118.285 63.3438 122.327 82.5299 130.591 112.529C137.308 136.921 150.05 172.144 121.981 187.07C113.134 191.767 98.1892 189.583 88.2139 190.474C90.9079 190.238 99.2632 184.941 101.284 182.92C114.736 169.468 110.695 150.282 102.431 120.283C94.0935 89.9932 84.6279 55.6803 111.077 29.2312C137.526 2.78204 171.857 12.2477 202.129 20.5847C210.885 23.0057 218.694 25.0081 225.72 26.3733V56.1172C215.108 54.4607 204.514 51.5482 194.356 48.7631C164.358 40.4989 145.19 36.4396 131.738 49.8917Z"
                                  fill="#354E79"
                                />
                                <path
                                  d="M62.4438 206.57C64.8102 208.936 64.8102 213.069 62.4438 215.435C61.8637 216.017 61.1744 216.479 60.4153 216.795C59.6562 217.11 58.8424 217.272 58.0204 217.272C57.1985 217.272 56.3846 217.11 55.6256 216.795C54.8665 216.479 54.1772 216.017 53.5971 215.435L37.9424 195.084L45.7333 187.293L62.4438 206.57Z"
                                  fill="#F9A825"
                                />
                                <path
                                  d="M23.7534 168.324C26.138 166.54 29.6694 168.998 30.8526 170.181L45.7246 187.31L37.9337 195.101L23.0799 175.806C21.8785 174.604 20.2402 170.945 23.7534 168.324ZM92.5976 201.854C93.7704 203.031 94.4288 204.625 94.4288 206.287C94.4288 207.948 93.7704 209.542 92.5976 210.719C91.4144 211.902 89.849 212.558 88.1743 212.558C86.4996 212.558 84.9341 211.902 83.7509 210.719L53.1515 179.847L60.7786 172.22L92.5976 201.854Z"
                                  fill="#355078"
                                />
                                <path
                                  d="M22.2937 141.917C24.8967 139.642 28.8104 142.263 31.2496 144.702L60.7751 172.225L53.148 179.852L23.8228 150.272C21.5838 147.942 19.272 144.538 22.2937 141.917ZM110.033 184.421C112.399 186.788 112.399 190.92 110.033 193.286C108.856 194.459 107.262 195.117 105.6 195.117C103.939 195.117 102.345 194.459 101.168 193.286L70.441 162.559L79.3059 153.694L110.033 184.421Z"
                                  fill="#FB897B"
                                />
                                <path
                                  d="M26.9776 116.488C26.9776 114.813 27.6329 113.247 28.8161 112.046C29.9932 110.873 31.587 110.215 33.2486 110.215C34.9101 110.215 36.5039 110.873 37.681 112.046L79.3116 153.677L70.4466 162.542L28.8161 120.911C28.2311 120.333 27.7672 119.644 27.4515 118.884C27.1359 118.125 26.9747 117.31 26.9776 116.488Z"
                                  fill="#355078"
                                />
                                <path
                                  d="M123.255 160.526C125.621 162.893 126.877 166.788 124.511 169.155C124.511 169.155 120.907 171.83 118.467 169.391L89.5791 143.434L97.37 135.643L123.255 160.526Z"
                                  fill="#FFF7F4"
                                />
                                <path
                                  d="M54.5664 109.223C54.5664 107.548 55.2217 105.983 56.4049 104.799C57.5881 103.616 59.1718 102.961 60.8283 102.961C62.503 102.961 64.0866 103.616 65.2516 104.799L97.3438 135.636L89.5528 143.426L56.4049 113.664C55.821 113.082 55.358 112.389 55.0425 111.627C54.727 110.865 54.5652 110.048 54.5664 109.223Z"
                                  fill="#5778B1"
                                />
                                <path
                                  d="M123.435 134.329C125.802 136.695 127.258 140.099 125.784 141.92C124.309 143.74 121.178 144.268 117.465 140.482C116.009 138.989 110.857 133.728 105.123 127.885L112.641 120.367L123.435 134.329Z"
                                  fill="#355078"
                                />
                                <path
                                  d="M84.1045 103.897C84.1045 102.295 84.7234 100.693 85.943 99.4738C87.1201 98.301 88.7139 97.6426 90.3755 97.6426C92.037 97.6426 93.6309 98.301 94.8079 99.4738L105.238 110.814L112.629 120.371L105.111 127.889C96.2096 118.805 85.9248 108.32 85.9248 108.32C84.7234 107.101 84.1045 105.499 84.1045 103.897Z"
                                  fill="#F9A825"
                                />
                                <path
                                  d="M149.615 119.399C150.787 120.576 151.446 122.17 151.446 123.832C151.446 125.493 150.787 127.087 149.615 128.264C148.437 129.437 146.844 130.095 145.182 130.095C143.521 130.095 141.927 129.437 140.75 128.264C140.75 128.264 132.485 118.708 124.094 108.914L131.612 101.396L149.615 119.399Z"
                                  fill="#FB897B"
                                />
                                <path
                                  d="M106.119 80.197C108.176 78.7226 111.034 80.8523 112.217 82.0356L130.075 99.8928L131.604 101.422L124.086 108.94C116.168 99.6926 108.14 90.227 106.866 88.3884C105.919 87.005 103.116 82.345 106.119 80.197ZM179.769 114.692C182.136 117.058 182.136 121.19 179.769 123.557C178.592 124.73 176.998 125.388 175.337 125.388C173.675 125.388 172.081 124.73 170.904 123.557L141.179 91.8288L149.024 83.9833L179.769 114.692Z"
                                  fill="#355078"
                                />
                                <path
                                  d="M108.713 52.4903C110.679 49.6506 113.209 48.7951 117.578 52.4903L149.033 83.9453L141.187 91.7909L110.66 59.2073C109.441 57.9876 107.311 54.5473 108.713 52.4903Z"
                                  fill="#FB897B"
                                />
                                <path
                                  d="M197.207 97.2704C198.38 98.4475 199.038 100.041 199.038 101.703C199.038 103.364 198.38 104.958 197.207 106.135C196.03 107.308 194.436 107.966 192.775 107.966C191.113 107.966 189.519 107.308 188.342 106.135L157.67 75.3356L166.535 66.4707L197.207 97.2704Z"
                                  fill="#5778B1"
                                />
                                <path
                                  d="M120.457 35.3502C120.457 33.6756 121.113 32.1101 122.296 30.9269C123.473 29.7542 125.067 29.0957 126.728 29.0957C128.39 29.0957 129.984 29.7542 131.161 30.9269L166.548 66.4594L157.683 75.3243L121.113 38.5904C119.929 37.4072 120.457 37.0249 120.457 35.3502Z"
                                  fill="#FFF7F4"
                                />
                                <path
                                  d="M203.061 67.8077C207.594 72.1764 210.015 75.3438 208.522 77.783C206.811 80.5863 204.245 81.2234 198.329 76.4177C195.962 74.4882 186.642 66.042 176.357 56.6309L184.039 48.9492L203.061 67.8077Z"
                                  fill="#355078"
                                />
                                <path
                                  d="M141.742 22.0579C141.742 20.456 142.361 18.8542 143.581 17.6163C144.758 16.4436 146.352 15.7852 148.013 15.7852C149.675 15.7852 151.269 16.4436 152.446 17.6163L184.046 48.9439L176.365 56.6256C161.056 42.6274 143.581 26.4813 143.581 26.4813C142.998 25.9013 142.536 25.212 142.22 24.4529C141.905 23.6938 141.742 22.8799 141.742 22.0579Z"
                                  fill="#FB897B"
                                />
                                <path
                                  d="M120.705 182.454C130.607 177.557 136.214 169.475 139.29 160.501C139.199 175.81 134.867 190.627 121.925 203.57C95.4754 230.019 61.1443 220.571 30.8725 212.216C22.1168 209.795 14.3077 207.793 7.28125 206.428V176.684C17.8937 178.34 28.4879 181.253 38.6452 184.038C60.0703 189.954 96.1307 194.632 120.705 182.454ZM122.944 39.1772C108.127 41.1249 97.0045 51.4279 97.0045 51.4279C97.0045 51.4279 98.5335 46.6223 101.846 41.0339C104.322 36.8836 107.708 32.5877 111.075 29.2019C137.525 2.75275 171.856 12.2184 202.128 20.5554C210.883 22.9764 218.692 24.9788 225.719 26.344V56.0879C215.106 54.4314 204.512 51.5189 194.355 48.7338C171.819 42.5266 146.444 36.1009 122.944 39.1772Z"
                                  fill="#5778B1"
                                />
                                <path
                                  d="M203.763 121.937C177.314 148.386 142.983 138.938 112.711 130.583C101.316 127.452 39.7531 100.73 12.5576 141.905C12.5576 141.905 17.9457 104.043 50.2199 92.4112C76.2686 83.0184 115.387 101.003 120.484 102.423C151.884 111.069 181.282 114.492 207.058 90.6273C212.956 85.1663 219.236 76.4652 220.619 68.5469C219.982 72.0783 228.064 97.6355 203.763 121.937Z"
                                  fill="#F8A294"
                                />
                              </svg>
                              DNA Insights
                            </Flex>
                          </FakeNavLinkSub>
                        </Fragment>
                      </CollapsibleNavLinkSection>
                    )}
                </Fragment>
              )}

              {/* {isMember ? (
                <>
                  <NavLink id="link_careTeam" exact to="/my-care-team" onClick={this.handleSidebar}>
                    Your Care Team
                  </NavLink>

                  <FakeNavLink id="link_community" onClick={this.onCommunityClick}>
                    Community
                  </FakeNavLink>
                </>
              ) : (
                <>
                  {isDiagnosed &&
                    isToggleActive('MEMBERSHIP') && (
                      <NavLink id="link_inviteFriends" exact to="/become-member" onClick={this.handleSidebar}>
                        Become a Member
                      </NavLink>
                    )}
                  <FakeNavLink id="link_community" onClick={this.onCommunityClick}>
                    Community
                  </FakeNavLink>
                  <DesktopOnly>
                    <NavLink id="link_inviteFriends" exact to="/invite-friends" onClick={this.handleSidebar}>
                      Invite Your Friends
                    </NavLink>
                  </DesktopOnly>
                </>
              )} */}
            </Sidebar>
          )}
          <Flex
            flex={1}
            mt={[
              !window.ReactNativeWebView ? (displayB2BnotVerified ? '160px' : '80px') : '0px',
              !window.ReactNativeWebView ? (displayB2BnotVerified ? '140px' : '80px') : '0px',
              !window.ReactNativeWebView ? (displayB2BnotVerified ? '120px' : '80px') : '0px',
            ]}
            ml={['0', '0', isSchedulePage || isMobileCourseEditor || isHealthCoachFormEditor || isRxProductPage ? '0' : '250px']}
            onClick={() => (isSidebarOpen ? this.setState({ isSidebarOpen: false }) : null)}
          >
            {(!t ? (
              window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email
            ) : (
              !!adm
            )) ? (
              <Route exact path="/" component={LandingAdmin} heartbeat={this.props.heartbeat} />
            ) : (
              <Route exact path="/" component={Landing} heartbeat={this.props.heartbeat} />
            )}
            {/* <Route path="/yearlyReview" component={YearlyReview} /> */}
            <Route exact path="/my-care-team" component={MyCareTeam} heartbeat={this.props.heartbeat} />
            <Route path="/tmp-test" component={TmpTest} heartbeat={this.props.heartbeat} />
            <Route exact path="/my-saving-card" component={MemberDrugSavingCard} heartbeat={this.props.heartbeat} />
            <Route exact path="/invite-friends" component={Referral} heartbeat={this.props.heartbeat} />
            <Route path="/account" component={MyAccount} heartbeat={this.props.heartbeat} />
            <Route path="/my-care" component={MyCare} heartbeat={this.props.heartbeat} />
            <Route path="/my-account" component={Account} heartbeat={this.props.heartbeat} />
            <Route path="/my-privacy" component={MyPrivacy} heartbeat={this.props.heartbeat} />
            <Route path="/my-payment-methods" component={MyPaymentMethods} heartbeat={this.props.heartbeat} />
            <Route path="/subscription/update/success/:id" component={SubscriptionUpdated} heartbeat={this.props.heartbeat} />
            <Route path="/eligibility-confirmation/:uid" component={EligibilityConfirmation} heartbeat={this.props.heartbeat} />
            <Route path="/my-subscriptions" component={MySubscriptions} heartbeat={this.props.heartbeat} />
            <Route path="/subscription/refund/:id" component={MySubscriptionRefund} heartbeat={this.props.heartbeat} />
            <Route path="/my-eligibility" component={MyEligibility} heartbeat={this.props.heartbeat} />
            <Route path="/insurance-member/change-insurance" component={ChangeInsuranceMemberInsurance} heartbeat={this.props.heartbeat} />
            <Route path="/my-insurances/add" exact component={AddNewInsurance} isPrimary={true} heartbeat={this.props.heartbeat} />
            <Route path="/my-insurances/add-secondary" exact component={AddNewInsurance} isPrimary={false} heartbeat={this.props.heartbeat} />
            <Route path="/my-insurances" exact component={MyInsurances} heartbeat={this.props.heartbeat} />
            <Route path="/subscription-updated" component={SubscriptionChangesConfirm} heartbeat={this.props.heartbeat} />
            <Route path="/cancel-membership" component={CancelMembership} heartbeat={this.props.heartbeat} />
            <Route path="/cancel-subscription" component={CancelSubscription} heartbeat={this.props.heartbeat} />
            <Route path="/pause-subscription" component={PauseSubscription} heartbeat={this.props.heartbeat} />
            <Route path="/labs-trend" component={LabResultsTrendPage} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/book/success/:f" component={SubscribedBook} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/confirm/:f" component={SubscribedConfirm} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/purchase/success/:f" component={SubscribedPurchase} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/call/:f" component={SubscribedCall} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/vitamins/:f" component={SubscribedContinueVits} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/insurance/vitamins/:f" component={SubscribedContinueInsurance} heartbeat={this.props.heartbeat} />
            <Route path="/subscribed/insurance/call/:f" component={SubscribedContinueInsurance} heartbeat={this.props.heartbeat} />
            <Route path="/subscribe-membership" component={SelectPlanPage} heartbeat={this.props.heartbeat} />
            <Route path="/schedule-care" component={ScheduleCareManager} heartbeat={this.props.heartbeat} />
            <Route path="/chat-care" component={ChatCareTeam} heartbeat={this.props.heartbeat} />
            <Route path="/post-register" component={AsyncPostRegister} heartbeat={this.props.heartbeat} />
            <Route path="/activate-sms-login" component={ActivateSmsLoginFeature} heartbeat={this.props.heartbeat} />

            <Route path="/visits/resume/:sku" exact component={MyRxResume} heartbeat={this.props.heartbeat} />

            <Route heartbeat={this.props.heartbeat} path="/labs" component={LabResults2} />
            <Route exact heartbeat={this.props.heartbeat} path="/programs/gut-reset" component={GutReset} />
            <NotDisqualifiedRoute heartbeat={this.props.heartbeat} exact path="/consultations-communicator/:id" component={MobileCommunicatorPage} />
            <NotDisqualifiedRoute heartbeat={this.props.heartbeat} exact path="/consultations-communicator" component={MobileCommunicatorPage} />
            <NotDisqualifiedRoute heartbeat={this.props.heartbeat} path="/consultations-communicator-async/:id" component={MobileAsyncCommunicatorPage} />
            <Route exact heartbeat={this.props.heartbeat} path="/programs/gut-reset-communicator" component={MobileCommunicatorGutResetPage} />

            <Route exact heartbeat={this.props.heartbeat} path="/rx-products" component={PalomaRxProducts} />
            <Route exact heartbeat={this.props.heartbeat} path="/rx-products/:id" component={PalomaRxProductDetails} />
            <Route heartbeat={this.props.heartbeat} path="/my-rx" component={myRx} />

            <RouteSection path="/consultations-summary" redirectTo="/consultations" heartbeat={this.props.heartbeat} />
            <RouteSection path="/labs-summary" redirectTo="/labs" heartbeat={this.props.heartbeat} />
            <Route path="/order-vitamins" component={orderVitamins} heartbeat={this.props.heartbeat} />
            <Route path="/order-vitamins-confirm/:session_id" component={VitaminsOrderConfirmation} heartbeat={this.props.heartbeat} />
            <DiagnosedHypoRouteWithSessionRoute heartbeat={this.props.heartbeat} path="/consultations" component={ConsultationsV3} />
            <DiagnosedHypoOrHashiRouteWithSessionRoute heartbeat={this.props.heartbeat} path="/consultations-nutritionist" component={ScheduleNutritionist} />
            <Route path="/schedule-nutritionist-gi" heartbeat={this.props.heartbeat} component={ScheduleNutritionistGi} />
            {/* <Route path="/labs" component={Labs} heartbeat={this.props.heartbeat} /> */}
            <Route path="/uploadLabResults" component={UploadLabResultsPage} heartbeat={this.props.heartbeat} />
            <Route path="/uploadGiLabResults" component={UploadGILabResultsPage} heartbeat={this.props.heartbeat} />

            <Route path="/uploadLabResultsSuccess" component={UploadLabResultsSuccess} />
            <Route path="/schedule-complete" component={ScheduleNewPatientComplete} heartbeat={this.props.heartbeat} />
            <NotDisqualifiedRoute path="/pharmacy" component={Pharmacy} heartbeat={this.props.heartbeat} />
            <NotDisqualifiedRoute path="/lab-center" component={LabCenter} heartbeat={this.props.heartbeat} />
            <NotDisqualifiedRoute heartbeat={this.props.heartbeat} path="/practitioner" component={Practitioner} />
            <Route path="/support" component={Support} heartbeat={this.props.heartbeat} />
            <Route path="/register-kit" component={RegisterKit} heartbeat={this.props.heartbeat} />
            <Route path="/registered-kit" component={RegisteredKit} heartbeat={this.props.heartbeat} />
            <Route path="/register-kit-payment" component={registerKitPayment} heartbeat={this.props.heartbeat} />
            <Route path="/register-kit-addons" component={RegisterKitAdditionalBiomarkers} heartbeat={this.props.heartbeat} />
            <Route path="/lab-orders" component={LabOrders} heartbeat={this.props.heartbeat} />
            <Route path="/change-me-account" component={ProfilePage} />
            <Route path="/articles/:id" exact component={ViewArticle} />
            <Route path="/articles" exact component={ViewArticles} />
            <Route path="/recipes/:id" exact component={ViewRecipe} />
            <Route path="/recipes" exact component={ViewRecipes} />
            <Route path="/speaker-series" exact component={SpeakerSeries} />
            <Route path="/thyroid-guides" exact component={ThyroidGuides} />
            <Route path="/visit-visio" component={VisitVisio} heartbeat={this.props.heartbeat} />
            <Route path="/visit-room" component={VisitVisio} heartbeat={this.props.heartbeat} />
            <Route path="/visit-room/:id" component={VisitVisio} heartbeat={this.props.heartbeat} />
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canChangeEmail) && <AdminRoute path="/change-email" component={ChangeEmail} heartbeat={this.props.heartbeat} />}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.mobileMan) && (
              <>
                {/* <AdminRoute path="/course-editor" component={MobileCourseDesigner} heartbeat={this.props.heartbeat} /> */}
                <AdminRoute path="/admin-mobile-symptom-tracker" component={MobileSymptomTrackers} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-mobile-webflow-articles" component={MobileWebflowArticles} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-mobile-recipes" component={MobileRecipes} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-mobile-motivation-quotes" component={MobileMotivationQuotes} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-mobile-courses" component={MobileCourses} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-preset-plans" component={AdminPresetPlans} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-preset-plan/:id" component={AdminPresetPlan} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-workouts" component={AdminWorkouts} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-mobile-push-notification" component={AdminSendMobileNotifications} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canUnithroid) && (
              <>
                <AdminRoute path="/admin-mobile-symptom-tracker-unithroid" component={MobileSymptomTrackersUnithroid} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canAdminProvidersApp) && (
              <>
                <AdminRoute path="/admin-create-provider-user" component={CreateProviderUser} heartbeat={this.props.heartbeat} />
                {/* <AdminRoute path="/admin-create-healthcoach-user" component={CreateHealthCoachUser} heartbeat={this.props.heartbeat} /> */}
                <AdminRoute path="/admin-view-healthcoaches" component={AdminHealthCoaches} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canB2BManagement) && (
              <>
                <AdminRoute path="/admin-b2b-management" component={AdminB2BManagement} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canMobileUserManagement) && (
              <>
                <AdminRoute path="/admin-mobile-change-user-week" component={AdminSetMobileUserWeek} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-delete-mobile-user" component={DeleteMobileUser} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-reset-mobile-user-week" component={AdminResetUserWeek} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-update-mobile-profile" component={AdminMobileContactInfo} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canRemapAccount) && (
              <>
                <AdminRoute path="/remap-account" component={MapLocalAccountToAthenaId} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/remap-associated-user-to-mobile" component={RemapMobileUserAssociatedUser} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/remap-pwn" component={RemapPwn} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-move-to-bridge" component={TransformAppointmentToBridge} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canStripeUserManagement) && (
              <>
                <AdminRoute path="/admin-patient-stripe-change" component={ChangeStripeId} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-patient-helpscout-change" component={ChangeHelpscoutId} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.imp) && (
              <>
                <AdminRoute path="/admin-impersonate-patient/:id" exact component={ImpersonatingChange} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-impersonate-patient" exact component={ImpersonatingChange} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canReporting) && (
              <>
                <AdminRoute path="/admin-reports" component={AdminReports} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/admin-backfill" component={BigQueryBackfill} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canFeatureTogglesManagement) && (
              <>
                <AdminRoute path="/feature-toggles-management" component={FeatureTogglesManagement} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canBatchMigrateProviderGroups) && (
              <>
                <AdminRoute path="/batch-migrate-provider-group" component={BatchMapToNewProviderGroup} heartbeat={this.props.heartbeat} />
                <AdminRoute path="/run-pr" component={AdminRunPr} heartbeat={this.props.heartbeat} />
              </>
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canOneTimeCouponManagement) && (
              <AdminRoute path="/one-time-coupons-management" component={OneTimeCouponsManagement} heartbeat={this.props.heartbeat} />
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canGenerateOtp) && (
              <AdminRoute path="/generate-otp" component={AdminGenerateOtp} heartbeat={this.props.heartbeat} />
            )}
            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canViewAdminsLogs) && (
              <AdminRoute path="/admin-logs" component={AdminViewAdminLogs} heartbeat={this.props.heartbeat} />
            )}

            {(!t ? window._env_.REACT_APP_PALOMA_ADMIN_EMAIL === email : !!adm && !!adm.canAdminHealthCoachApp) && (
              <>
                <AdminRoute path="/hc-template-builder" component={HealthCoachFormBuilderWrap} />
                <AdminRoute path="/hc-template-list" component={HealthCoachFormsList} />
              </>
            )}

            <AdminRoute path="/reorder-physician-convo" component={AdminReorderPhysicianConvo} />
            <AdminRoute path="/admin-bulk-activate-survey-flag" component={AdminBulkSetSurveyFlag} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/referrals-management" component={AdminReferralList} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/batch-balance" component={BatchBalanceAdjustment} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/pending-registration" component={PendingProfileCompletionUsers} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/unregister-kit" component={UnregisterKitLocalDb} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/reset-intake-status" component={ResetPatientIntakeStatus} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/test-mobile-notifications-preview" component={AdminTestNotifications} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/my-logs" component={AdminViewMyLogs} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/duplicated-ids" component={AdminIdentifyDups} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-batch-slots" component={AdminBatchCreateSlots} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-care-managers" component={AdminCareManagers} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-bridge" component={AdminBridge} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-search-patients" component={AdminSearchPatient} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-sc" component={AdminSc} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-reset-token" component={AdminGetReset} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-recommendation-summary-data" component={AdminGetRecommendationSummaryData} heartbeat={this.props.heartbeat} />
            <AdminRoute logout={this.timeoutLogout} heartbeat={this.heartbeat} path="/OtpValidities" component={AdminOtpValidities} />
            <AdminRoute path="/admin-departments-list" component={AdminDepartments} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-provider-schedule" component={AdminViewProviderCalendar} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/admin-edit-departments" component={AdminRegionEdits} heartbeat={this.props.heartbeat} />
            {/* <AdminRoute path="/AdminBannerFilterBuilder/:id/:versionId" component={AdminBannerFilterBuilder} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/AdminBannerFilterBuilder/:id" component={AdminBannerFilterBuilder} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/AdminBannerFilterBuilder" component={AdminBannerFilterBuilder} heartbeat={this.props.heartbeat} />
            <AdminRoute path="/AdminBannerFilterList" component={AdminBannerFilterList} heartbeat={this.props.heartbeat} /> */}

            {/* <Route
              heartbeat={this.heartbeat}
              exact
              path="/schedule/doc/:id"
              component={Schedule}
            /> */}
            <Route heartbeat={this.props.heartbeat} path="/schedule-legacy" component={Schedule} />
            <Route heartbeat={this.props.heartbeat} path="/schedule" component={ScheduleBridge} />
            <Route heartbeat={this.props.heartbeat} path="/scheduling" component={BookConsultationNoHypo} />
            <Route heartbeat={this.props.heartbeat} path="/scheduler" component={BookConsultation} />
            <Route heartbeat={this.props.heartbeat} path="/scheduler-meno" component={BookConsultationMeno} />
            <Route heartbeat={this.props.heartbeat} path="/schedule-split" component={ScheduleSplit} />
            <Route heartbeat={this.props.heartbeat} path="/smart-intake" component={smartIntake} />
            <Route heartbeat={this.props.heartbeat} path="/schedulemeno" component={ScheduleBridgeMeno} />
            <Route heartbeat={this.props.heartbeat} path="/schedulemeno-legacy" component={ScheduleMeno} />
            <Route heartbeat={this.props.heartbeat} path="/schedulewl-legacy" component={ScheduleWeightLoss} />
            <Route heartbeat={this.props.heartbeat} path="/schedulewl" component={ScheduleBridgeWL} />
          </Flex>
        </Outlet>

        <MergeAccountsModal />
        <>
          <SessionTimeout
            heartbeat={() => {
              // console.log('HB init')
              this.props.heartbeat();
            }}
            client={this.props.client}
            logout={() => {
              localStorage.removeItem('token');
              if (this.props.location && this.props.location.pathname) {
                localStorage.setItem('route', this.props.location.pathname);
              } else {
                localStorage.removeItem('route');
              }
              this.props.history.push('/logout');
            }}
          />
        </>
      </Container>
    );
  }
}

const RouteSection = ({ session, redirectTo, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const token = localStorage.getItem('token');

      if (token) {
        // rest.heartbeat()
        // return <Component {...props} />;
        // if (!rest.heartbeat()) {
        //   localStorage.setItem('route', props.location.pathname);
        //   return <Redirect to={{ pathname: '/login' }} />;
        // } else {
        return <Redirect to={{ pathname: redirectTo }} />;
        // }
      } else {
        localStorage.setItem('route', props.location.pathname);
        return <Redirect to={{ pathname: '/login' }} />;
      }
    }}
  />
);
const AdminRouteWithSession = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const token = localStorage.getItem('token');
      if (token) {
        const t = isToggleActive('PERSONAL_ADMIN');
        if (!rest.session || (!t ? rest.session.email !== window._env_.REACT_APP_PALOMA_ADMIN_EMAIL : !rest.session.adm)) {
          return <Redirect to={{ pathname: rest.fallback || '/' }} />;
        }
        // rest.heartbeat()
        // return <Component {...props} />;
        // if (!rest.heartbeat()) {
        //   localStorage.setItem('route', props.location.pathname);
        //   return <Redirect to={{ pathname: '/login' }} />;
        // } else {
        return <Component {...props} isAdminView />;
        // }
      } else {
        localStorage.setItem('route', props.location.pathname);
        return <Redirect to={{ pathname: '/login' }} />;
      }
    }}
  />
);

const AdminRoute = withSession(AdminRouteWithSession);

const NotDisqualifiedRouteWithSession = ({ component: Component, session, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const { intakeStatus } = session;
      if (intakeStatus !== 'disqualified') {
        const token = localStorage.getItem('token');
        if (token) {
          // rest.heartbeat()
          // return <Component {...props} />;
          // if (!rest.heartbeat()) {
          //   localStorage.setItem('route', props.location.pathname);
          //   return <Redirect to={{ pathname: '/login' }} />;
          // } else {
          return <Component {...props} />;
          // }
        } else {
          localStorage.setItem('route', props.location.pathname);
          return <Redirect to={{ pathname: '/login' }} />;
        }
      } else {
        return <Redirect to={{ pathname: '/' }} />;
      }
    }}
  />
);

const DiagnosedHypoRouteWithSession = ({ component: Component, session, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // const { intakeStatus, diagnoseFull } = session;
      // if (intakeStatus !== 'disqualified' && ((diagnoseFull && diagnoseFull.hasHypo) || (diagnoseFull && diagnoseFull.hasAppointment))) {

      const { intakeStatus, diagnoseFull, eligibility } = session;
      // if (intakeStatus !== 'disqualified' && diagnoseFull && (diagnoseFull.hasHypo || diagnoseFull.hasHashi || diagnoseFull.hasAppointmentNutritionist)) {
      if (diagnoseFull || eligibility.canBookPerimenopause || eligibility.canBookPostmenopause) {
        const token = localStorage.getItem('token');
        // console.log({ token, ...rest });
        if (token) {
          // rest.heartbeat()
          // return <Component {...props} />;
          // const hb= aw
          // if (!rest.heartbeat()) {
          //   console.log('no heartbeat')
          //   localStorage.setItem('route', props.location.pathname);
          //   return <Redirect to={{ pathname: '/login' }} />;
          // } else {
          return <Component {...props} />;
          // }
        } else {
          localStorage.setItem('route', props.location.pathname);
          return <Redirect to={{ pathname: '/login' }} />;
        }
      } else {
        return <Redirect to={{ pathname: '/' }} />;
      }
    }}
  />
);

const DiagnosedHypoOrHashiRouteWithSession = ({ component: Component, session, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const { intakeStatus, diagnoseFull, eligibility } = session;
      if (intakeStatus !== 'disqualified' && diagnoseFull && (diagnoseFull.hasHypo || diagnoseFull.hasHashi || diagnoseFull.hasAppointmentNutritionist)) {
        // if (diagnoseFull || eligibility.canBookPerimenopause || eligibility.canBookPostmenopause) {
        const token = localStorage.getItem('token');
        if (token) {
          // rest.heartbeat()
          // return <Component {...props} />;
          // if (!rest.heartbeat()) {
          //   localStorage.setItem('route', props.location.pathname);
          //   return <Redirect to={{ pathname: '/login' }} />;
          // } else {
          return <Component {...props} />;
          // }
        } else {
          localStorage.setItem('route', props.location.pathname);
          return <Redirect to={{ pathname: '/login' }} />;
        }
      } else {
        return <Redirect to={{ pathname: '/' }} />;
      }
    }}
  />
);

const NutritionistWithSession = ({ component: Component, session, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const { intakeStatus, diagnoseFull } = session;
      if (intakeStatus !== 'disqualified' && diagnoseFull && (diagnoseFull.hasHypo || diagnoseFull.hasHashi || diagnoseFull.hasAppointmentNutritionist)) {
        const token = localStorage.getItem('token');
        if (token) {
          // rest.heartbeat()
          // return <Component {...props} />;
          // if (!rest.heartbeat()) {
          //   localStorage.setItem('route', props.location.pathname);
          //   return <Redirect to={{ pathname: '/login' }} />;
          // } else {
          return <Component {...props} />;
          // }
        } else {
          localStorage.setItem('route', props.location.pathname);
          return <Redirect to={{ pathname: '/login' }} />;
        }
      } else {
        return <Redirect to={{ pathname: '/' }} />;
      }
    }}
  />
);

const NotDisqualifiedRoute = withSession(NotDisqualifiedRouteWithSession);
const DiagnosedHypoRouteWithSessionRoute = withSession(DiagnosedHypoRouteWithSession);
const DiagnosedHypoOrHashiRouteWithSessionRoute = withSession(DiagnosedHypoOrHashiRouteWithSession);

export default withApollo(withAnalytics(withSession(Dashboard)));
